<template>
  <div>
    <el-card>
      <div class="flex flex-align-center gap-10">
        <div class="keyLabel" style="width:80px">关键字：</div>
        <el-select v-model="keyType" style="width:120px">
          <el-option v-for="(v,i) in keyList" :value="v.value" :label="v.label"></el-option>
        </el-select>
        <el-input v-model.trim="keywords" style="width:250px" :placeholder="placeholder"></el-input>
      </div>
      <div class="flex flex-align-center gap-10 margin-top-20">
        <div class="keyLabel" style="width:80px">报单时间：</div>
        <el-date-picker
          v-model="offerTime"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="flex flex-align-center gap-20 margin-top-20">
        <div class="flex flex-align-center gap-10">
          <div class="keyLabel" style="width:80px">订单状态：</div>
          <el-select v-model="state" style="width:120px">
            <el-option v-for="(v,i) in stateList" :value="v.value" :label="v.label"></el-option>
          </el-select>
        </div>
        <div class="flex flex-align-center gap-10">
          <div class="keyLabel" style="width:80px">退款类型：</div>
          <el-select v-model="type" style="width:120px">
            <el-option v-for="(v,i) in typeList" :value="v.value" :label="v.label"></el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
        <buttonPermissions :datas="'XITAIOrderCollectEnter'">
          <el-dropdown @command="exportOrder">
            <el-button>
              订单录入<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">批量导入</el-dropdown-item>
              <el-dropdown-item command="2">手工录单</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </buttonPermissions>
        <buttonPermissions :datas="'XITAIOrderCollectSend'">
          <el-button @click="deliverShow=true">批量发货</el-button>
        </buttonPermissions>
        <buttonPermissions :datas="'XITAIOrderCollectExport'">
          <el-button @click="exportFile">导出</el-button>
        </buttonPermissions>
        <el-button type="text" @click="reset">重置筛选条件</el-button>
      </div>
      
      <div class="table-container" style="margin-top:10px">
        <el-table border style="width: 100%;" v-loading="loading" ref="multipleTable" :data="groupData"
          :row-class-name="setClassName" :span-method="arraySpanMethod" :header-row-style="headerStyle">
          <el-table-column label="商品" width="220px">
            <template slot-scope="scope">
              <div class="header-box" v-if='scope.row.type===1'
                :style="{background:scope.row.type == 1?'rgba(64, 158, 255,.1)':'transparents'}">
                <div class="header-info">
                  <el-checkbox v-model="scope.row.check" @change="(e)=>{chooseCheck(e,scope.row)}"> <span></span> </el-checkbox>
                  <span>订单：{{scope.row.OrderNo}}</span>
                  <span>外部单号：{{scope.row.OutOrderNo}}</span>
                  <span>报单时间：{{scope.row.AddTime}}</span>
                  <span>分销商：{{scope.row.EmployeeName}}</span>
                </div>
              </div>
              <div class="product-name-box" v-else-if='scope.row.type===2'>
                <div class="product-name">
                  <span>{{scope.row.ProductName}}</span>
                </div>
              </div>
              <div class="remark-box" v-else>
                <div class="customer-remark" v-if="scope.row.CustomerRemark">买家留言:{{scope.row.CustomerRemark}}</div>
                <div class="system-remark" v-if="scope.row.SystemRemark">系统备注:{{scope.row.SystemRemark}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <div style="color:#606266;">
                <div class="ellipsis" v-if="scope.row.SpecValue || scope.row.SpecValue2">
                  <span v-if="scope.row.SpecValue">{{scope.row.SpecValue}}</span>
                  <span v-if="scope.row.SpecValue2">;{{scope.row.SpecValue2}}</span>
                </div>
                <div v-else>默认规格</div>
                <div class="color-999999">
                  {{scope.row.BarCode}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ProductCount" label="数量" width="80"></el-table-column>
          <el-table-column prop="" label="单价(元)">
            <template slot-scope="scope">
              <div>
                <div>企店：{{scope.row.QiDianDistributePrice}}</div>
                <div>分销商：{{scope.row.ProductPrice}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="合计(元)">
            <template slot-scope="scope">
              <div>
                <div>企店：{{scope.row.QiDianDistributeMoney}}</div>
                <div>分销商：{{scope.row.ProductMoney}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="收件人" width="320">
            <template slot-scope="scope">
              <div>
                <div>
                  {{scope.row.ReceiveName}}({{scope.row.ReceivePhone}})
                </div>
                <div>
                  {{scope.row.ReceiveProvince + scope.row.ReceiveCity + scope.row.ReceiveArea + scope.row.ReceiveAddress}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="OrderStateValue" label="订单状态" width="80"></el-table-column>
          <el-table-column label="物流信息" width="145">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.ExpressNo">
                  <div>
                    {{scope.row.ExpressValue}}
                  </div>
                  <div>
                    {{scope.row.ExpressNo}}
                  </div>
                </div>
                <div v-else>
                  --
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="退款信息">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.RefundTypeValue">
                  <div>{{scope.row.RefundTypeValue}}</div>
                  <div>{{scope.row.RefundReason}}</div>
                  <div>{{scope.row.RefundReturnExpressNo}}</div>
                </div>
                <div v-else>--</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <div class="flex flex-align-center gap-10 flex-wrap">
                <buttonPermissions :datas="'XITAIOrderCollectCancel'" v-if="scope.row.OrderState==0">
                  <el-button type="text" style="color:#f56c6c" @click="cancelOrder(scope.row)">取消订单</el-button>
                </buttonPermissions>
                <buttonPermissions :datas="'XITAIOrderCollectSend'" v-if="scope.row.OrderState==10">
                  <el-button type="text" @click="sendFunction(scope.row)">发货</el-button>
                </buttonPermissions>
                <buttonPermissions :datas="'XITAIOrderCollectReturn'" v-if="scope.row.OrderState==20">
                  <el-button type="text" style="color:#f56c6c" @click="returnOrder(scope.row)">退货退款</el-button>
                </buttonPermissions>
                <buttonPermissions :datas="'XITAIOrderCollectRefund'" v-if="scope.row.OrderState==10">
                  <el-button type="text" style="color:#f56c6c" @click="refundOrder(scope.row)">仅退款</el-button>
                </buttonPermissions>
                <!-- <buttonPermissions :datas="'XITAIOrderCollectChange'" v-if="scope.row.OrderState!=30">
                  <el-button type="text" @click="toChangeOnce(scope.row)">修改价格</el-button>
                </buttonPermissions> -->
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="flex flex-align-center flex-justify-between margin-top-10">
          <div class="flex flex-align-center gap-10">
            <el-checkbox :value="allcheck" @change="checkAll"> 当前页全选 </el-checkbox>
            <buttonPermissions :datas="'XITAIOrderCollectCheck'">
              <el-dropdown @command="handleCommand">
                <el-button>
                  审核订单<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">审核选中订单</el-dropdown-item>
                  <el-dropdown-item command="2">审核全部订单</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </buttonPermissions>
            <!-- <buttonPermissions :datas="'XITAIOrderCollectChange'">
              <el-button @click="toChangePrice">修改价格</el-button>
            </buttonPermissions> -->
          </div>
          <el-pagination v-if="Total" style="margin-top:10px" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="Total">
          </el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog :visible.sync="changePriceBatchShow" title="批量修改价格" custom-class="dialog-body-paddingTop-10" width="600px" v-loading="changePriceBatchLoading">
      <div class="form" style="margin-top:0px">
        <div class="flex flex-align-center">
          <div class="form-label label-star">报单时间：</div>
          <el-date-picker
            style="width:380px"
            v-model="batchChangeMsg.offerTime"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="flex margin-top-20">
          <div class="form-label">分销商：</div>
          <div>
            <div>
              <el-radio-group v-model="batchChangeMsg.fenxiaoshang" style="margin-top:7px">
                <el-radio :label="null">不限</el-radio>
                <el-radio :label="1">指定分销商</el-radio>
              </el-radio-group>
            </div>
            <el-select v-model="batchChangeMsg.fxsid" v-if="batchChangeMsg.fenxiaoshang==1" class="margin-top-20" style="width:380px"
              placeholder="请选择分销商">
              <el-option v-for="(v,i) in fxsList" :key="i" :value="v.value" :label="v.label"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex margin-top-20">
          <div class="form-label label-star" style="line-height:30px">修改商品：</div>
          <div style="width:380px">
            <div class="flex flex-align-center gap-10">
              <el-input v-model="changeKeywords" class="flex-1" placeholder="请输入商品规格编码"></el-input>
              <el-button type="primary" @click="searchShop">查询</el-button>
            </div>
            <div class="shopBox flex flex-align-center gap-10 font-14 color-606266 margin-top-10" v-if="batchChangeMsg.shopId">
              <img src="" alt="">
              <div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-align-center margin-top-20" v-if="batchChangeMsg.shopId">
          <div class="form-label label-star" style="line-height:30px">新价格：</div>
          <el-input v-model="batchChangeMsg.xjg" style="width:150px"
            oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="flex-align-center margin-top-20" style="text-align:right">
          <el-button @click="changePriceBatchShow=false">关闭</el-button>
          <el-button type="primary" @click="confirmChange">确认修改</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="sendShow" title="发货" custom-class="dialog-body-paddingTop-10" width="600px" v-loading="sendLoading">
      <div class="form" style="margin-top:0px">
        <div class="flex flex-align-center">
          <div class="form-label label-star">物流公司：</div>
          <el-radio-group v-model="sendMsg.ExpressValue" style="margin-top:5px">
            <el-radio label="中通快递">中通快递</el-radio>
            <el-radio label="圆通快递">圆通快递</el-radio>
            <el-radio label="顺丰快递">顺丰快递</el-radio>
          </el-radio-group>
        </div>
        <div class="flex flex-align-center margin-top-20">
          <div class="form-label label-star">物流单号：</div>
          <el-input v-model="sendMsg.ExpressNo" placeholder="物流单号" style="width:380px"></el-input>
        </div>
        <div class="flex-align-center margin-top-20" style="text-align:right">
          <el-button @click="sendShow=false">关闭</el-button>
          <el-button type="primary" @click="confirmSend">确认发货</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="returnShow" title="退货退款" custom-class="dialog-body-paddingTop-10" width="600px" v-loading="returnLoading">
      <div class="form" style="margin-top:0px">
        <div class="flex flex-align-center">
          <div class="form-label label-star">退回单号：</div>
          <el-input v-model="returnMsg.RefundReturnExpressNo" style="" placeholder="退回单号" maxlength="50"></el-input>
        </div>
        <div class="flex margin-top-20">
          <div class="form-label">退款说明：</div>
          <el-input v-model="returnMsg.RefundReason" type="textarea" :rows="6" placeholder="退款说明" maxlength="100"></el-input>
        </div>
        <div class="flex-align-center margin-top-20" style="text-align:right">
          <el-button @click="returnShow=false">关闭</el-button>
          <el-button type="primary" @click="confirmReturn">确认退款</el-button>
        </div>
      </div>
    </el-dialog>
    
    <el-dialog :visible.sync="refundShow" title="仅退款" custom-class="dialog-body-paddingTop-10" width="600px" v-loading="refundLoading">
      <div class="form" style="margin-top:0px">
        <div class="flex">
          <div class="form-label">退款说明：</div>
          <el-input v-model="refundMsg.RefundReason" type="textarea" :rows="6" placeholder="退款说明" maxlength="100"></el-input>
        </div>
        <div class="flex-align-center margin-top-20" style="text-align:right">
          <el-button @click="refundShow=false">关闭</el-button>
          <el-button type="primary" @click="confirmRefund">确认退款</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="changeOnceShow" title="修改价格" custom-class="dialog-body-paddingTop-10" width="600px" v-loading="changeOnceLoading">
      <div class="form" style="margin-top:0px">
        <div class="flex flex-align-center margin-top-20">
          <div class="form-label">分销商：</div>
          <div>打撒大萨达所大打撒大萨达所大打撒大萨达所大</div>
        </div>
        <div class="flex flex-align-center margin-top-20">
          <div class="form-label">订单号：</div>
          <div>打撒大萨达所大打撒大萨达所大打撒大萨达所大</div>
        </div>
        <div class="flex margin-top-20">
          <div class="form-label" style="line-height:30px">修改商品：</div>
          <div style="width:380px">
            <div class="shopBox flex flex-align-center gap-10 font-14 color-606266 margin-top-10">
              <img src="" alt="">
              <div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-align-center margin-top-20">
          <div class="form-label label-star" style="line-height:30px">新价格：</div>
          <el-input v-model="rowmsg.xjg" style="width:150px"
            oninput="value=((value.replace(/[^0-9.]/g,'')).replace(/([0-9]+\.[0-9]{2})[0-9]*/,'$1'))">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="flex-align-center margin-top-20" style="text-align:right">
          <el-button @click="changeOnceShow=false">关闭</el-button>
          <el-button type="primary" @click="confirmChangeOnce">确认修改</el-button>
        </div>
      </div>
    </el-dialog>

    <batch-enter :show="batchEnterShow" @close="batchEnterShow=false"></batch-enter>

    <batch-deliver :show="deliverShow" @close="deliverShow=false"></batch-deliver>
  </div>
</template>

<script>
import buttonPermissions from '@/components/buttonPermissions';
import batchEnter from "../components/batchEnter"
import batchDeliver from "../components/batchDeliver"
import {
  cittaDistributionOrderlist,
  cittaDistributionOrdercancel,
  cittaDistributionOrdersend,
  cittaDistributionOrdercheck,
  cittaDistributionOrdercheckAll,
  cittaDistributionOrderrefundOnly,
  cittaDistributionOrderreturnRefund,
} from "@/api/sv3.0.0"
import {
  nextDay
} from "@/utils"
export default {
  components: {
    buttonPermissions,
    batchEnter,
    batchDeliver
  },
  data () {
    return {
      keyType:1,
      keyList:[
        {value:1,label:'订单号',placeholder:'订单号、外部单号'},
        {value:2,label:'分销商',placeholder:'分销商名称、帐号'},
        {value:3,label:'规格编码',placeholder:'规格编码'},
        {value:4,label:'商品名称',placeholder:'商品名称'},
        {value:5,label:'物流单号',placeholder:'物流单号'},
      ],
      keywords:'',
      offerTime:[],
      state:null,
      stateList:[
        {value:null,label:'全部'},
        {value:0,label:'待审核'},
        {value:10,label:'待发货'},
        {value:20,label:'已发货'},
        {value:30,label:'已取消'},
      ],
      type:null,
      typeList:[
        {value:null,label:'全部'},
        {value:1,label:'仅退款'},
        {value:2,label:'退货退款'},
      ],
      groupData:[],
      loading:false,
      Total:0,
      currentPage:1,
      pageSize:20,
      selectionList:[],
      changePriceBatchShow:false,
      changePriceBatchLoading:false,
      batchChangeMsg:{},
      fxsList:[],
      changeKeywords:'',
      rowmsg:{},
      sendShow:false,
      sendLoading:false,
      sendMsg:{},
      returnShow:false,
      returnLoading:false,
      returnMsg:{},
      refundShow:false,
      refundLoading:false,
      refundMsg:{},
      changeOnceShow:false,
      changeOnceLoading:false,
      batchEnterShow:false,
      deliverShow:false,
    }
  },
  computed: {
    placeholder(){
      return this.keyList.find(v=>v.value==this.keyType).placeholder
    },
    allcheck(){
      return this.selectionList.length==this.groupData.filter(v=>String(v.check)!='undefined').length&&this.selectionList.length>0
    },
  },
  watch:{

  },
  mounted () {
    this.gettablelist()
  },
  methods: {
    exportOrder(e){
      if(e==1){
        this.batchEnterShow = true
      }else{
        this.$router.push({
          path:'/XITAIDistribution/XITAIOrderEnter'
        })
      }
    },
    async confirmChangeOnce(){
      if(!String(this.rowmsg.xjg)||this.rowmsg.xjg<0||this.rowmsg.xjg>99999){
        this.$message.error('价格设置在0~99999元之间')
        return
      }
      try{
        this.changeOnceLoading = true
        let res = await ({})
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.changeOnceShow = false
          this.gettablelist()
        }
      }finally{
        this.changeOnceLoading = false
      }
    },
    toChangeOnce(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
      this.changeOnceShow = true
    },
    async confirmRefund(){
      try{
        this.refundLoading = true
        let res = await cittaDistributionOrderrefundOnly({
          OrderNo:this.rowmsg.OrderNo,
          ...this.refundMsg
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.refundShow = false
          this.gettablelist()
        }
      }finally{
        this.refundLoading = false
      }
    },
    refundOrder(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
      this.refundMsg = {
        RefundReason:''
      }
      this.refundShow = true
    },
    async confirmReturn(){
      if(!this.returnMsg.RefundReturnExpressNo){
        this.$message.error('请输入单号')
        return
      }
      try{
        this.returnLoading = true
        let res = await cittaDistributionOrderreturnRefund({
          OrderNo:this.rowmsg.OrderNo,
          ...this.returnMsg
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.returnShow = false
          this.gettablelist()
        }
      }finally{
        this.returnLoading = false
      }
    },
    returnOrder(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
      this.returnMsg = {
        RefundReturnExpressNo:'',
        RefundReason:''
      }
      this.returnShow = true
    },
    cancelOrder(row){
      this.$confirm('操作不可撤消，是否确认取消订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try{
            this.loading = true
            let res = await cittaDistributionOrdercancel({
              OrderNo:row.OrderNo
            })
            if(res.IsSuccess){
              this.$message.success('操作成功')
              this.gettablelist()
            }
          }finally{
            this.loading = false
          }
        })
    },
    async confirmSend(){
      if(!this.sendMsg.ExpressNo){
        this.$message.error('请输入物流单号')
        return
      }
      try{
        this.sendLoading = true
        let res = await cittaDistributionOrdersend({
          OrderNo:this.rowmsg.OrderNo,
          ...this.sendMsg
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.sendShow = false
          this.gettablelist()
        }
      }finally{
        this.sendLoading = false
      }
    },
    sendFunction(row){
      this.rowmsg = JSON.parse(JSON.stringify(row))
      this.sendMsg = {
        ExpressValue:'中通快递',
        ExpressNo:''
      }
      this.sendShow = true
    },
    async confirmChange(){
      if(this.batchChangeMsg.fenxiaoshang==1&&!this.batchChangeMsg.fxsid){
        this.$message.error('请选择分销商')
        return
      }
      if(!this.batchChangeMsg.shopId){
        this.$message.error('请输入商品规格编码查询商品')
        return
      }
      if(!String(this.batchChangeMsg.xjg)||this.batchChangeMsg.xjg<0||this.batchChangeMsg.xjg>99999){
        this.$message.error('价格设置在0~99999元之间')
        return
      }
      try{
        this.changePriceBatchLoading = true
        let res = await ({})
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.changePriceBatchShow = false
          this.gettablelist()
        }
      }finally{
        this.changePriceBatchLoading = false
      }
    },
    async searchShop(){
      if(!this.changeKeywords){
        this.$message.error('请输入商品规格编码查询商品')
        return
      }
      try{
        let res = await ({})
        if(res.IsSuccess){
          this.batchChangeMsg.shopId = ''
          this.batchChangeMsg.shopImg = ''
          this.batchChangeMsg.shopName = ''
          this.batchChangeMsg.shopCode = ''
        }
      }finally{
        //
      }
    },
    toChangePrice(){
      this.batchChangeMsg = {
        offerTime:[],
        fenxiaoshang:null,
        fxsid:'',
        shopId:'',
        shopImg:'',
        shopName:'',
        shopCode:'',
        xjg:'',
      }
      this.changePriceBatchShow = true
    },
    handleCommand(e){
      this.$confirm('操作不可撤消，是否确认审核订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '关闭',
        type: 'warning'
      }).then(() => {
        if(e==1){
          if(!this.selectionList||!this.selectionList.length){
            this.$message.error('请选择订单')
            return
          }
          if(!this.selectionList.filter(v=>v.OrderState==0).length){
            this.$message.error('请选择待审核订单')
            return
          }
          this.checkChooseOrder()
        }else{
          this.checkAllOrder()
        }
      })
    },
    async checkChooseOrder(){
      let num = 0
      try{
        this.loading = true
        for(let item of this.selectionList){
          let res = await cittaDistributionOrdercheck({
            OrderNo:item.OrderNo
          })
          num++
        }
      }finally{
        if(num==this.selectionList.length){
          this.$message.success('操作成功')
          this.gettablelist()
        }
        this.loading = false
      }
    },
    async checkAllOrder(){
      try{
        this.loading = true
        let res = await cittaDistributionOrdercheckAll()
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.loading = false
      }
    },
    chooseCheck(e,row){
      if(!e){
        this.selectionList = this.selectionList.filter(v=>v.OrderNo!=row.OrderNo)
      }else{
        this.selectionList.push(row)
      }
    },
    checkAll(e){
      this.groupData = this.groupData.map(v=>{
        if(String(v.check)!='undefined'){
          v.check = e
        }
        return v
      })
      if(e){
        this.selectionList = this.groupData.filter(v=>v.check)
      }else{
        this.selectionList = []
      }
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pageSize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    async gettablelist(){
      try{
        this.loading = true
        let data = {
          Type:2,
          KeywordsType:this.keyType,
          Keywords:this.keywords,
          OrderState:this.state,
          RefundType:this.type,
          Skip:(this.currentPage-1)*this.pageSize,
          Take:this.pageSize,
        }
        if(this.offerTime&&this.offerTime.length){
          data.StartTime = this.offerTime[0]
          data.EndTime = nextDay(this.offerTime[1],1)
        }

        let res = await cittaDistributionOrderlist(data)
        if(res.IsSuccess){
          this.Total = res.Result.Total
          this.dealData(res)
        }
      }finally{
        this.loading = false
      }
    },
    dealData(result) {
      let list = result.Result.Results || [];
      this.groupData = []
      list.forEach((t) => {
        let item = {
          type: 1,
          ...t,
          check:false,
        }
        this.groupData.push(item)
        t.OrderDetailList.forEach((tt, ii) => {
          let iitem = {}
          if (ii === 0) {
            iitem = {
              ...tt,
              type: 2,
              length: t.OrderDetailList.length,
              ...t,
            }
          } else {
            iitem = {
              ...tt,
              type: 2,
              OrderNo: t.OrderNo,
              ...t,
            }
          }
          this.groupData.push(iitem)
        })
        if (t.CustomerRemark || t.SystemRemark) {
          let item = {
            type: 3,
            ...t
          }
          this.groupData.push(item)
        }
      })

    },
    headerStyle() {
      return {
        background: '#f0f2f5'
      }
    },
    setClassName({row,index}) {
      if (row.type == 1) {
        return 'special-row'
      }
    },
    arraySpanMethod({row,column,rowIndex,columnIndex}) {
      if (row.type === 1 || row.type === 3) {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 10
          };
        } else {
          return {
              rowspan: 0,
              colspan: 0
            };
        }
      }else{
        if(columnIndex>4){
          if (row.length) {
            return {
              rowspan: row.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    reset(){
      this.keyType = 1
      this.keywords = ''
      this.offerTime = []
      this.state = null
      this.type = null
      this.handleCurrentChange(1)
    },
    exportFile(){
      let url = location.origin + '/pc/cittaDistributionOrder/export'
      url += '?KeywordsType=' + this.keyType
      url += '&Type=' + 2
      url += '&Keywords=' + encodeURI(this.keywords)
      url += '&OrderState=' + (this.state==null?'':this.state)
      url += '&RefundType=' + (this.type==null?'':this.type)
      if(this.offerTime&&this.offerTime.length){
        url += '&StartTime=' + this.offerTime[0]
        url += '&EndTime=' + nextDay(this.offerTime[1],1)
      }
      window.open(url)
    }
  }
}
</script>

<style lang='less' scoped>
.keyLabel{
  text-align: right;
}
  .shopBox{
    width: 100%;
    background: #F8F8F9;
    border: 1px solid #EBEEF5;
    padding:10px;

    img{
      width:60px;height:60px
    }
  }
	.table-container {
		::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
			background-color: rgba(0, 0, 0, 0) !important;
		}

		.header-box {
			display: flex;
			padding: 0 10px;
			flex-direction: row;
			justify-content: space-between;
			align-content: center;

			.header-info {
				span {
					display: inline-block;
					line-height: 40px;
					margin-right: 20px;
				}
			}

			.header-btn {
				min-width: 120px;
			}
		}

		.remark-box {
			.remark-distribution{
				background: rgba(245, 244, 247,1);
				color: #f56c6c;
				padding: 10px;
				word-wrap: break-word;
				width: 100%;
			}
			.customer-remark {
				background: rgba(217, 236, 255, 1);
				color: rgba(64, 158, 255, 1);
				padding: 10px;
				word-wrap: break-word;
				width: 100%;
        // padding-left:20px
			}

			.system-remark {
				background: rgba(253, 246, 236, 1);
				color: rgba(253, 162, 60, 1);
				padding: 10px;
				word-wrap: break-word;
				width: 100%;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				font-size: 14px;
			}
		}

		.product-name-box {
			.product-name {
				width: 200px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}
		}

		::v-deep .special-row {
			padding-top: 10px;

			td {
				padding: 10px 0 0 0 !important;
			}

			.cell {
				padding: 0 !important;
			}

			.name-wraper {
				padding: 5px 10px;

				.line span {
					line-height: 30px;
					display: inline-block;
				}
			}
		}
	}
</style>